export default __webpack_public_path__ + "static/media/WebResume2.be59c8fd.png";